import { z } from 'zod';

import { c } from '../../contract';
import { BlockedUser } from '../../types';

const userBlockResponse = z.object({
  block: BlockedUser,
});

export const userBlocksRouter = c.router(
  {
    getBlockedUsers: {
      summary: 'Get blocked users for the authenticated user',
      method: 'GET',
      path: '',
      responses: {
        200: z.object({
          blocks: z.array(BlockedUser),
        }),
      },
    },
    blockUser: {
      summary: 'Block a user for the authenticated user',
      method: 'POST',
      path: '',
      body: z.object({
        blockedUserId: z.string(),
        contextCommentId: z.number().optional(),
      }),
      responses: {
        201: userBlockResponse,
        400: z.object({
          status: z.literal('rejected'),
          reason: z.literal('self-block'),
        }),
        409: z.object({
          status: z.literal('already-blocked'),
          block: BlockedUser,
        }),
      },
    },
    unblockUser: {
      summary: 'Unblock a user for the authenticated user',
      method: 'DELETE',
      path: '/:blockedUserId',
      pathParams: z.object({
        blockedUserId: z.string(),
      }),
      responses: {
        204: c.noBody(),
        404: z.object({
          status: z.literal('rejected'),
          reason: z.literal('not-found'),
        }),
      },
    },
  },
  {
    pathPrefix: '/users/me/blocks',
  },
);
